import { AxiosError } from 'axios';
import { PUT_GROUP_EXAM_REGISTRATION_START_FILE_PROCESSING } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PutStartFileProcessingRequest {
  applicationUuid: string;
  fileUuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutStartFileProcessing = ({ onSuccess, onError }: Input) => {
  const putStartFileProcessing = async (payload: PutStartFileProcessingRequest) => {
    await axiosClient.put<undefined>(
      PUT_GROUP_EXAM_REGISTRATION_START_FILE_PROCESSING(payload.applicationUuid),
      {
        uuid: payload.fileUuid,
      }
    );
  };

  return useCustomMutation(putStartFileProcessing, {
    onSuccess,
    onError,
  });
};
